var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cursor-pointer ml-4",on:{"click":_vm.copyExample}},[_c('vs-icon',_vm._b({attrs:{"color":_vm.color}},'vs-icon',_vm.$iconData('icon-copy', 'fi-rr-copy-alt'),false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }